import useDialogue from "../useDialogue/useDialogue";
import { getSearchType, getSearchTypes } from "../useChat/useModel.js";
import { deviceInfo } from "./deviceInfo";
import {
  CHARACTER_TYPE,
  REWRITE_TYPE,
  CONTENT_COMPLETION_TYPE,
  NOVEL_WRITE,
  CONTENT_WRITE,
} from "@/views/Home/useData/module/constant";

const {
  dialogueList,
  dialogueStatus,
  init,
  addDialogue,
  setSessionId,
  nextDialoguePage,
  deleteDialogue,
  deleteSelectDialogue,
  renameDialogue,
  postTopDialogue,
} = useDialogue({
  type: deviceInfo?.isMobile ? undefined : getSearchType("chatSP"),
  excludeType: getSearchTypes([
    CHARACTER_TYPE,
    REWRITE_TYPE,
    CONTENT_COMPLETION_TYPE,
    NOVEL_WRITE,
    CONTENT_WRITE,
  ]),
  // type: getSearchType("chat"),
  addNew: true,
});

export {
  dialogueList,
  dialogueStatus,
  init,
  addDialogue,
  setSessionId,
  nextDialoguePage,
  deleteDialogue,
  deleteSelectDialogue,
  renameDialogue,
  postTopDialogue,
};
